import React, { useState, useEffect, useRef } from 'react';
import { FilterComponent } from '../../components/Filter';
import Layout from '../../components/layout';
import { useMediaQuery } from '../../helpers/useMediaQuery';
import TableComponent from '../../components/Table';
import { navigate } from 'gatsby';
import qs from 'qs';
import { getColumns, filterByContinent } from './helpers';
import { TableController } from '../../components/TableController';
import { Modal } from '../../components/Modals';
import { getModalProps } from '../../components/TableController/modalProps';
import Sticky from 'react-stickynode';
export default function GlobalPassportPower({ location, pageContext }) {
	const isPageWide = useMediaQuery('(min-width: 1200px)');
	const setQuery = (params) => {
		const newPath = `?${qs.stringify(params)}`;
		return navigate(newPath, {
			state: {
				disableScrollUpdate: true,
			},
		});
	};

	const stickyElement = useRef(null);
	const { fullRankingList, heading, description, isInner, columnName } =
		pageContext;
	const [rankingList, setRankingList] = useState([]);

	const searchParams = qs.parse(location.search?.replace('?', ''));
	const [continent, setContinent] = useState(searchParams?.continent);
	const [country, setCountry] = useState(searchParams?.country);
	const [countryData, setCountryData] = useState(searchParams?.country);
	const [limit, setLimit] = useState(20);

	const scrollToActive = () =>
		setTimeout(() => {
			const section = document.querySelector('.section-wrapper');
			const element = document.querySelector('tr.active');
			let top = section.offsetTop - 180;
			if (element) top = element.offsetTop + 180;
			window.scrollTo({ top, behavior: 'smooth' });
		}, 0);
	useEffect(() => {
		const fullList = [...fullRankingList];
		let filteredList = fullList;
		if (continent) {
			setQuery({ continent: continent?.value || continent });
			filteredList = filterByContinent({ fullList, continent });
		}
		if (country) {
			setQuery({ country: country?.value || country });
		}
		if (!continent && !country) {
			setLimit(20);
			setQuery({ continent: undefined, country: undefined });
		}

		setRankingList(filteredList);
	}, [continent, country]);

	const [columns, setColumns] = useState([]);

	useEffect(getColumns(setColumns, isPageWide, columnName), [isPageWide]);

	const [isModalOpen, setIsModalOpen] = useState(false);
	const [modalType, setModalType] = useState('download');
	const openModal = (modalType) => (e) => {
		if (e?.preventDefault) e.preventDefault();

		if (typeof e === 'string') {
			const countryData = rankingList.find(({ iso2c }) => iso2c === e);
			setCountryData(countryData);
		}

		setModalType(modalType);
		setIsModalOpen(true);
	};
	const filterProps = {
		slug: pageContext.slug,
		continent,
		setContinent: (continent) => {
			setContinent(continent?.value || continent);
			scrollToActive();
		},
		country,
		setCountry: (...args) => {
			setCountry(...args);
			scrollToActive();
		},
		openModal,
		href: location?.href,
		heading,
		description,
	};

	const modalProps = getModalProps({
		...countryData,
		...filterProps,
		setIsModalOpen,

		href: location?.href,
		heading,
		description,
	});
	const isDefault = columnName === 'default';
	return (
		<Layout introConfig={{ heading, description, isInner }}>
			<div>
				{!isPageWide && (
					<div>
						<TableController {...filterProps} />
						<Modal
							{...modalProps[modalType]}
							isModalOpen={isModalOpen}
							setIsModalOpen={setIsModalOpen}
							slug={pageContext.slug}
						/>
					</div>
				)}
				<div className="container section-wrapper mb-8">
					{isPageWide && (
						<Sticky
							ref={stickyElement}
							enabled={true}
							top={180}
							bottomBoundary={'#bottom-boundary'}
						>
							<FilterComponent {...filterProps} />
						</Sticky>
					)}
					<div className="section-content relative">
						<TableComponent
							columns={columns}
							data={rankingList}
							country={country}
							hasLoadMore={true}
							limit={200}
							openModal={
								!isDefault
									? (e) => {
											openModal(columnName)(e);
									  }
									: null
							}
						/>
						<div
							style={{ position: 'absolute', bottom: 300 }}
							id="bottom-boundary"
						></div>
					</div>
				</div>
			</div>
		</Layout>
	);
}
